import React from "react";
import TitlePage from "../../../app/Title/TitlePage";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Dialog} from "primereact/dialog";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Dropdown} from "primereact/dropdown";
import {Divider} from "@material-ui/core";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const GuaranteesTableView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Control de Límite \ Tablas de Garantías"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button label="Buscar"
                                style={{'float': 'right'}}
                                onClick={props.getDataGuaranteesTable}/>
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.dataGuaranteesTable}
                            selectionMode="single"
                            onSelectionChange={props.handleSelectRow}
                            selection={props.rowSelected}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="NomCorto" header="Institución"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="DescrAforo" header="Aforo para la Institución"
                                    style={{textAlign: 'left'}}
                                    body={props.formatDescription} sortable={true}/>
                            <Column header="Acciones"
                                    style={{textAlign: 'left', width: '8em'}}
                                    body={props.guaranteesTableActionTemplate}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog visible={props.displayDialog}
                    header={props.dialogHeader}
                    modal={true}
                    onHide={props.onHideDialog}
                    closable={false}
                    contentStyle={{overflow:'visible'}}
            >

                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-12 p-lg-4">
                        <SubtitleLabel header="Institución Actual" isBold={true}/>
                        <SubtitleLabel header={props.rowSelected.actualInstitution}/>
                    </div>
                    <div className="p-col-12 p-md-12 p-lg-4">
                        <SubtitleLabel header="Institución para Operar" isBold={true}/>
                        <SubtitleLabel header={props.rowSelected.NomCorto}/>
                    </div>
                    <div className="p-col-12 p-md-12 p-lg-4">
                        <SubtitleLabel header="Tipo de Aforo" isBold={true}/>
                        <Dropdown placeholder="Seleccione..."
                                      name="aforoObj"
                                      filter={true}
                                      required={true}
                                      filterBy="tipoAforo"
                                      optionLabel="tipoAforo"
                                      options={props.listAforos}
                                      value={props.rowSelected.aforoObj}
                                      onChange={props.onChangeValue}/>
                    </div>
                </div>
            </Dialog>
            {props.confirmationMessage}
        </React.Fragment>
    )
};

export default GuaranteesTableView;